import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MatanotRouting } from './matanot.routes';

import { CustomerMatanaFilter } from "./shared/pipes/custom-matana-filter.pipe";
import { CustomerYechidaFilter } from "../shared/pipes/custom-yechida-filter.pipe";
import { CustomerYechidatMishneDdlFilter } from "../shared/pipes/custom-yechidat-mishneddl-filter.pipe";
import { ChalukaFilterPipe } from "./shared/pipes/chaluka-filter-pipe";

import { MatanotReportsComponent } from '../reports/matanot-reports/matanot-reports.component';
import { MatanotComponent } from './matanot.component'
import { MatanotHomeComponent } from "./home/home.component";
import { EndRishumMatanaComponent } from "./end-rishum-matana/end-rishum-matana.component";
import { EndTkufatRishumComponent } from "./end-tkufat-rishum/end-tkufat-rishum.component";

import { HomeChalukatComponent } from "./chaluka/home/chaluka-home.component";
import { ChalukatMatanotComponent } from "./chaluka/chalukat-matanot.component";
import { UpdateChalukatComponent } from "./chaluka/update/chaluka-update.component";

import { SignaturePadModule } from 'angular2-signaturepad';



@NgModule({
    imports: [MatanotRouting, SharedModule,SignaturePadModule],
    declarations: [
        MatanotReportsComponent,
        MatanotComponent,
        MatanotHomeComponent,
        EndRishumMatanaComponent,
        EndTkufatRishumComponent,

        HomeChalukatComponent,
        ChalukatMatanotComponent,
        UpdateChalukatComponent,
        
        CustomerMatanaFilter,
        CustomerYechidaFilter,
        CustomerYechidatMishneDdlFilter,
        ChalukaFilterPipe

    ],
    
    exports:[]
})

export class MatanotModule { }
